import React from 'react';
import { Badge } from '../ui/badge';
import { cn, getStatusLabel } from '../../lib/utils';

const statusColors = {
  // Stato commessa
  attiva: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20',
  pianificazione: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20',
  sospesa: 'bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20',
  chiusa: 'bg-slate-500/10 text-slate-600 dark:text-slate-400 border-slate-500/20',
  // Stato cliente
  attivo: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20',
  non_attivo: 'bg-slate-500/10 text-slate-600 dark:text-slate-400 border-slate-500/20',
  // Tipo commessa
  cliente: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20',
  interna_rd: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/20',
  interna_presales: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20',
  interna_formazione: 'bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 border-cyan-500/20',
  interna_admin: 'bg-slate-500/10 text-slate-600 dark:text-slate-400 border-slate-500/20',
  // Tipo risorsa
  dipendente: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20',
  freelance: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/20',
  consulente: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20',
};

export const StatusBadge = ({ status, className, showLabel = true, ...props }) => {
  const colorClass = statusColors[status] || 'bg-slate-500/10 text-slate-600 dark:text-slate-400';
  
  return (
    <Badge 
      variant="outline"
      className={cn(
        "font-medium border",
        colorClass,
        className
      )}
      {...props}
    >
      {showLabel ? getStatusLabel(status) : status}
    </Badge>
  );
};

export default StatusBadge;
